import { Paper, Stack, Text, Title } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Session } from "types";
import { useStyles } from "./OrderBillingAddress.styles";

interface Props {
  session: Session;
}

export const OrderBillingAddress: React.FC<Props> = ({ session }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  if (!session.billing_address) return null;

  return (
    <Stack spacing="sm">
      <Title size="h6" className={classes.title}>
        {t("order.billingAddress")}
      </Title>

      <Paper withBorder p="sm" shadow="xs" radius="md">
        <Text>
          {`${session.shipping_address?.street_address}, ${session.shipping_address?.zip_code} ${session.shipping_address?.city}`}
        </Text>
      </Paper>
    </Stack>
  );
};
